import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import breakpoints from '../../../Theme/breakpoints';

const MoreFeaturedNewsWrapper = styled.section`
  @media (min-width: ${breakpoints.lg}px) {
    padding: 24px 0 0;
    border-top: 1px solid var(--grey-dark);
  }
`;

const MoreFeaturedNewsContainer = styled.div`
  display: block;

  @media (min-width: ${breakpoints.lg}px) {
    padding: 0 0 24px;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  @media (min-width: ${breakpoints.sm}px) {
    display: flex;
    flex-wrap: wrap;
  }
`;

const MoreFeaturedNewsItem = styled.div`
  margin: 0 0 24px;

  @media (min-width: ${breakpoints.sm}px) {
    flex-basis: calc(50% - (16px + 1px));
    padding: 0 16px 0 0;
    margin: 0 0 16px;

    &:nth-of-type(3) {
      padding: 0 16px 0 0;
    }

    &:nth-of-type(2) {
      padding: 0 0 0 16px;
      flex-basis: calc(50% - (16px + 1px));
    }

    &:nth-of-type(4) {
      padding: 0 0 0 16px;
      flex-basis: calc(50% - (16px + 1px));
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    &&& {
      flex-basis: calc(25% - 36px);
      margin: 0 12px 0 0;
      padding: 0;

      &:nth-of-type(4) {
        margin: 0;
      }
    }
  }
`;

const MoreFeaturedNews = ({
  moreFeaturedNewsArticles,
}) => (
  <MoreFeaturedNewsWrapper>
    <MoreFeaturedNewsContainer>
      {moreFeaturedNewsArticles}
    </MoreFeaturedNewsContainer>
  </MoreFeaturedNewsWrapper>
);

MoreFeaturedNews.propTypes = {
  moreFeaturedNewsArticles: PropTypes.node,
};

MoreFeaturedNews.defaultProps = {
  moreFeaturedNewsArticles: undefined,
};

export { MoreFeaturedNews, MoreFeaturedNewsItem };
